module.exports = __webpack_public_path__ + "static/media/zm.8d658b4d.svg";